import { forwardRef, useRef } from 'react';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import { generateUuid } from '@witmetrics/utils/uuid';
import { CloseIcon, EventIcon } from '@/icons';
import { styles } from './utils';

export type InputFieldProps = {
  className?: string;
  isOpen: boolean;
  label: string;
  value: string;
  hasValue: boolean;
  onClear: () => void;
  onClick: () => void;
};

const InputField = forwardRef<HTMLDivElement, InputFieldProps>(
  ({ className, isOpen, label, value, hasValue, onClear, onClick }, ref) => {
    const idRef = useRef(generateUuid());
    return (
      <FormControl
        focused={isOpen}
        className={className}
        size="small"
        variant="outlined">
        <InputLabel htmlFor={idRef.current}>{label}</InputLabel>
        <OutlinedInput
          ref={ref}
          id={idRef.current}
          label={label}
          value={value}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                sx={styles.iconButton}
                edge="end"
                aria-label="open/close calendar">
                <EventIcon />
              </IconButton>
              {hasValue && (
                <IconButton
                  sx={styles.iconButton}
                  edge="end"
                  aria-label="clear date field"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onClear();
                  }}>
                  <CloseIcon />
                </IconButton>
              )}
            </InputAdornment>
          }
          onClick={onClick}
          onFocus={(e) => e.target.blur()}
        />
      </FormControl>
    );
  }
);

export default InputField;
